function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['visualization']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
setupInterceptors(appApisGTW);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
var CONTROLLER_NAME = '/powerbi';
var DOMAIN_DATASETS = '/datasets';
var headers = {
  headers: {
    'Content-Type': 'application/json'
  }
};
export default {
  getDatasets: function getDatasets(data) {
    var _this = this;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/get_all', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getReports) Listar accesos de un usuario.';
      return validateError(err, message, function () {
        return _this.getDatasets(data);
      });
    });
  },
  getDatasetById: function getDatasetById(data) {
    var _this2 = this;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/get', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getReports) Listar accesos de un usuario.';
      return validateError(err, message, function () {
        return _this2.getDatasetById(data);
      });
    });
  },
  datasetInitWorkFlow: function datasetInitWorkFlow(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/init_workflow', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetInitWorkFlow) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.datasetInitWorkFlow(data)
      });
    });
  },
  datasetSendAssignment: function datasetSendAssignment(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/send_assigment', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetAddUpdate) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.datasetSendAssignment(data)
      });
    });
  },
  massiveApprove: function massiveApprove() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_DATASETS, "/massive_approve"), body).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  datasetAddUpdate: function datasetAddUpdate(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/add_update', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetAddUpdate) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.datasetAddUpdate(data)
      });
    });
  },
  datasetLogQuery: function datasetLogQuery(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/log_query', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetAddUpdate) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.datasetAddUpdate(data)
      });
    });
  },
  datasetPendingApproval: function datasetPendingApproval(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/pending_approval', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetAddUpdate) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.datasetAddUpdate(data)
      });
    });
  },
  datasetQuery: function datasetQuery(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/query', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetAddUpdate) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.datasetAddUpdate(data)
      });
    });
  },
  datasetQueryAllDomain: function datasetQueryAllDomain(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/query_all_domain', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetQueryAllDomain) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.datasetAddUpdate(data)
      });
    });
  },
  datasetSetPermission: function datasetSetPermission(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/set_permission', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetQueryAllDomain) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.datasetSetPermission(data)
      });
    });
  },
  setTemporalDataOperator: function setTemporalDataOperator(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/set_temporal_data_operator', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetQueryAllDomain) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.setTemporalDataOperator(data)
      });
    });
  },
  filterBusinessTerm: function filterBusinessTerm(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/filter_business_term', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetQueryAllDomain) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.filterBusinessTerm(data)
      });
    });
  },
  getReports: function getReports(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DATASETS + '/get_reports', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetQueryAllDomain) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.filterBusinessTerm(data)
      });
    });
  }
};